import {
  UPDATE_LOAD,
  RESET_LOAD,
  UPDATE_STOP,
  RESET_STOP,
  UPDATE_EVIDENCE,
  RESET_EVIDENCE
} from "./actionTypes"

export const update_load = load => {
  return {
    type: UPDATE_LOAD,
    payload: load,
  }
}

export const reset_load = load => {
  return {
    type: RESET_LOAD,
  }
}


//sTOPS
export const update_stop = stop => {
  return {
    type: UPDATE_STOP,
    payload: stop,
  }
}

export const reset_stop = stop => {
  return {
    type: RESET_STOP,
  }
}
//EVIDENCES
export const update_evidence = evidence => {
  return {
    type: UPDATE_EVIDENCE,
    payload: evidence,
  }
}

export const reset_evidence = evidence => {
  return {
    type: RESET_EVIDENCE,
  }
}
